/**
 * Updates document meta tags for the current route.
 * Set VUE_APP_SITE_URL in production (e.g. https://workmorr.com) for correct canonical & Open Graph URLs.
 */
const SITE_URL = (process.env.VUE_APP_SITE_URL || 'https://workmorr.com').replace(/\/$/, '')

const DEFAULT_DESCRIPTION =
  'Find jobs, hire verified talent, and book local services on a map—with messaging and tracked orders in one app. Free on iPhone and Android.'

export function getSiteUrl() {
  return SITE_URL
}

export function applyRouteSeo(to) {
  const path = to.path === '/' ? '/' : to.path
  const fullUrl = `${SITE_URL}${path === '/' ? '' : path}`

  if (to.name === '404') {
    setName('robots', 'noindex, follow')
  } else {
    setName('robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1')
  }

  const desc = (to.meta.description && String(to.meta.description).trim()) || DEFAULT_DESCRIPTION
  let tag = document.querySelector('meta[name="description"]')
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', 'description')
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', desc)

  const title = to.meta.ogTitle || (to.meta.title ? `Workmorr — ${to.meta.title}` : 'Workmorr | Jobs, talent & local services')
  setOg('og:title', title)
  setName('twitter:title', title)
  if (desc) {
    setOg('og:description', desc)
    setName('twitter:description', desc)
  }
  setOg('og:url', fullUrl)

  let canonical = document.querySelector('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }
  canonical.setAttribute('href', `${SITE_URL}${path === '/' ? '/' : path}`)
}

function setOg(property, content) {
  if (!content) return
  let tag = document.querySelector(`meta[property="${property}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('property', property)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

function setName(name, content) {
  if (!content) return
  let tag = document.querySelector(`meta[name="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}
